import styled from 'styled-components';
import { zIndex } from 'tokens';

export const PanelWrapper = styled.div`
	grid-area: left-panel;
	z-index: ${zIndex.panel};
	display: flex;
	flex-direction: column;
`;

export const ScrollingArea = styled.div`
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
	scrollbar-width: thin;
	&::-webkit-scrollbar {
		width: 8px;
	}
	scrollbar-color: ${({ theme }) => theme.gray[400]} ${({ theme }) => theme.gray[100]};
`;

export const Entries = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 8px;
`;

export const EmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 40px 20px;
	text-align: center;
	height: 100%;
`;

export const EmptyStateIcon = styled.div`
	margin-bottom: 16px;
	opacity: 0.6;
`;

export const EmptyStateText = styled.div`
	font-size: 16px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[800]};
	margin-bottom: 8px;
`;

export const EmptyStateSubtext = styled.div`
	font-size: 13px;
	color: ${({ theme }) => theme.gray[600]};
	line-height: 20px;
	max-width: 280px;
`;
